import React from "react";

import ActiveLeftAlignSvg from "../../assets/images/icons/active-left-align.svg";

export const ActiveLeftAlignIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={ActiveLeftAlignSvg}
        alt={alt || "Left Align"}
    />
);
